import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import CommonForm from "./CommonForm";
import ListComponent from "./ListComponent";

export default function CouponCategories(props) {
  return (
    <>
      <div className="flex-row-fluid" {...props}>
        <Switch>
          <Redirect
            from="/coupon-categories"
            exact={true}
            to="/coupon-categories/list"
          />
          <Route
            path="/coupon-categories/list"
            component={ListComponent}
          />
          <Route
            path="/coupon-categories/create"
            component={CommonForm}
          />
          <Route
            path="/coupon-categories/edit/:id"
            component={CommonForm}
          />
        </Switch>
      </div>
    </>
  );
}
